import Link from 'next/link';
import styled from 'styled-components';
import useModal from '../../hooks/useModal';
import Login from '../Login/login';
import Modal from '../modal';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import { UserContext } from '../../context/authContext';
import { signInWithGoogle } from '../../supabase';
import PaymentModal from '../PaymentModal';
import CompanyLogos from '../CompanyLogos';

interface PaymentType{
count?:number;
flows?:boolean;
showPaymentBanner:string;
}

const PaymentBanner = ({count, showPaymentBanner, flows = false }:PaymentType) => {
	const { loginToggleModal, isModalLogin,paymentShowModal,paymenttoggleModal } = useModal();
	const user = useContext(UserContext);
	const router = useRouter();
	const handleSignupWithGoogle = async () => {
		try {
			await signInWithGoogle(router.asPath);
		} catch (e) {
			console.log('Sorry an error occurred while trying to login');
		}
	};
	
	return (
		<>
			{isModalLogin && (
				<Modal toggleModal={loginToggleModal}>
					<Login toggleModal={loginToggleModal} />
				</Modal>
			)}
			{paymentShowModal && (
				<Modal toggleModal={paymenttoggleModal}>
					<PaymentModal/>
						</Modal>
					)}

			<Overlay flows={flows} />
		
			<MainWrapper>
	
				{/* //payment banner shows login button for all unauthenticated users and subscribe now for international users in paid brands */}
				{showPaymentBanner==="non-paying" ? (
					<PaymentButton>
						{flows
							? `Subscribe to View Flows of All ${count} App${count>1?`s`:``}`
							:  `Subscribe to View All ${count} Screens`}
						<div onClick={() => paymenttoggleModal()}>
							<span>Unlock Premium</span>
						</div>
					</PaymentButton>
				) : (
					<PaymentButton>
						{`Sign In to View More Screens`}
						<span
							onClick={() => handleSignupWithGoogle()}
							className='flex items-center '
						>
							<div
								style={{ width: '30px', height: '30px' }}
								className='h-30 mr-2'
							>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									viewBox='0 0 48 48'
									width='100%'
									height='100%'
								>
									<path
										fill='#FFC107'
										d='M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z'
									></path>
									<path
										fill='#FF3D00'
										d='M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z'
									></path>
									<path
										fill='#4CAF50'
										d='M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z'
									></path>
									<path
										fill='#1976D2'
										d='M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z'
									></path>
								</svg>
							</div>
							Sign In With Google{' '}
						</span>
					</PaymentButton>
				)}
			</MainWrapper>
			<CompanyLogos/>
		</>
	);
};

const Overlay = styled.div<{ flows: boolean }>`
	height: 200px;
	width: 100%;
	margin-top: ${({ flows }) => (flows ? '-350px' : '-250px')};
	background-image: linear-gradient(
		to bottom,
		#ffffff,
		#fafbff,
		#f3f7ff,
		#eaf4ff,
		#e0f1ff
	);
	filter: blur(35px);

	opacity: 0.8;
	box-shadow: -80px -80px 50px rgba(255, 255, 255, 0.4),
		-30px -30px 20px rgba(255, 255, 255, 0.8);
	/* margin-top: -250px; */
`;

const PaymentButton = styled.div`
	font-size: 20px;
	font-weight: 800;
	color: #000000;
	text-align: center;
	@media (min-width: 768px) {
		font-size: 36px;
		:span {
			font-size: 18px;
		}
	}

	span {
		margin-top: 0.5em;
		font-weight: 500;
		cursor: pointer;
		width: 250px;
		font-size: 14px;
		display: flex;
		color: #ffffff;
		padding: 0.8em;
		padding: 0.8em;
		margin: 1em auto;
		margin: 1em auto;
		justify-content: center;
		border-radius: 50px;
		background-color: var(--primary-color);
		border: 1px solid #8798be;
	}
	span {
		margin-top: 0.5em;
		font-weight: 500;
		cursor: pointer;
		width: 250px;
		font-size: 14px;
		display: flex;
		color: white;
		padding: 0.8em;
		margin: 1em auto;
		justify-content: center;
		border-radius: 50px;
		background-color: var(--primary-color);
		border: 1px solid #8798be;
	}
`;

const MainWrapper = styled.div`
	height: 300px;
	z-index:98;
	margin-top: -100px;
	width: 100%;
	background-image: linear-gradient(
		to bottom,
		#ffffff,
		#ffffff,
		#ffffff,
		#ffffff,
		#ffffff
	);
	box-shadow: -80px -80px 50px rgba(255, 255, 255, 0.4),
		-30px -30px 20px rgba(255, 255, 255, 1);
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
`;

export default PaymentBanner;
